export class UtmService {
    public static readonly UtmParams = ['utm_campaign', 'utm_source', 'utm_medium', 'utm_content', 'utm_term', 'utm_referrer'] as const;

    static processUtmValues = (handler: {
        [key in typeof UtmService.UtmParams[number]]?: (value: string | null, params: URLSearchParams) => void;
    }) => {
        const params = new URLSearchParams(window.location.search);

        UtmService.UtmParams.forEach((param) => {
            const handlerMethod = handler[param];
            if (handlerMethod) handlerMethod(params.get(param), params);
        });
    };

    /**
     * Persists the UTM parameters from the current URL into the session storage.
     */
    static persistParameters() {
        const params = new URLSearchParams(window.location.search);
        const utmParams = this.UtmParams;
        utmParams.forEach(param => {
            if (params.has(param)) {
                sessionStorage.setItem(param, params.get(param) as string);
            }
        });
    }

    /**
     * Restores the UTM parameters from the session storage to the current URL.
     * If a UTM parameter already exists in the URL, it will not be overwritten.
     */
    static restoreParameters() {
        const targetUrl = new URL(window.location.href);
        const utmParams = this.UtmParams;
        utmParams.forEach(param => {
            const utmSessionValue = sessionStorage.getItem(param);
            // never overwrite an already existing utm parameter in the url.
            if (utmSessionValue && !targetUrl.searchParams.get(param)) {
                targetUrl.searchParams.set(param, utmSessionValue);
            }
        });
        if (targetUrl.toString() !== window.location.href) {
            window.history.replaceState({ path: targetUrl.toString() }, '', targetUrl.toString());
        }
    }
}
